
    import * as React from 'react';

    const ArrowUpFilled20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" fill="none" style={svgStyle}><path d="M13.7929 12H6.20711L10 8.20711L13.7929 12Z" stroke="#191A1B" /></svg>
        </div>
      );
    };

    ArrowUpFilled20.displayName = 'ArrowUpFilled20';

    export default ArrowUpFilled20;
  